"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseUsersController", {
    enumerable: true,
    get: function() {
        return BaseUsersController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _baseusersservice = require("~/services/base-users/base-users.service");
const _catchError = require("~/helpers/catchError");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let BaseUsersController = class BaseUsersController {
    async userList(context, baseId, req) {
        var _ref;
        var _req_user;
        const baseRoles = Object.keys((_ref = (_req_user = req.user) == null ? void 0 : _req_user.base_roles) != null ? _ref : {});
        const mode = baseRoles.includes(_nocodbsdk.ProjectRoles.OWNER) || baseRoles.includes(_nocodbsdk.ProjectRoles.CREATOR) ? 'full' : 'viewer';
        return {
            users: await this.baseUsersService.userList(context, {
                baseId,
                mode
            })
        };
    }
    async userInvite(context, baseId, req, body) {
        // todo: move this to a service
        if (!body.email) {
            _catchError.NcError.badRequest('Email is required');
        }
        return await this.baseUsersService.userInvite(context, {
            baseId,
            baseUser: body,
            req
        });
    }
    async baseUserUpdate(context, baseId, userId, req, body) {
        await this.baseUsersService.baseUserUpdate(context, {
            baseUser: body,
            baseId,
            userId,
            req
        });
        return {
            msg: 'The user has been updated successfully'
        };
    }
    async baseUserDelete(context, baseId, userId, req) {
        await this.baseUsersService.baseUserDelete(context, {
            baseId,
            userId,
            req
        });
        return {
            msg: 'The user has been deleted successfully'
        };
    }
    async baseUserInviteResend(context, baseId, userId, req, body) {
        await this.baseUsersService.baseUserInviteResend(context, {
            baseId: baseId,
            userId: userId,
            baseUser: body,
            req
        });
        return {
            msg: 'The invitation has been sent to the user'
        };
    }
    async baseUserMetaUpdate(context, baseId, req, body) {
        return await this.baseUsersService.baseUserMetaUpdate(context, {
            baseId,
            body,
            user: req.user,
            req
        });
    }
    constructor(baseUsersService){
        this.baseUsersService = baseUsersService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/users',
        '/api/v2/meta/bases/:baseId/users'
    ]),
    (0, _extractidsmiddleware.Acl)('baseUserList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "userList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/users',
        '/api/v2/meta/bases/:baseId/users'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('userInvite'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.ProjectUserReqType === "undefined" ? Object : _nocodbsdk.ProjectUserReqType
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "userInvite", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/projects/:baseId/users/:userId',
        '/api/v2/meta/bases/:baseId/users/:userId'
    ]),
    (0, _extractidsmiddleware.Acl)('baseUserUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('userId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "baseUserUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/projects/:baseId/users/:userId',
        '/api/v2/meta/bases/:baseId/users/:userId'
    ]),
    (0, _extractidsmiddleware.Acl)('baseUserDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('userId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "baseUserDelete", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/users/:userId/resend-invite',
        '/api/v2/meta/bases/:baseId/users/:userId/resend-invite'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('baseUserInviteResend'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('userId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.ProjectUserReqType === "undefined" ? Object : _nocodbsdk.ProjectUserReqType
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "baseUserInviteResend", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/projects/:baseId/user',
        '/api/v2/meta/bases/:baseId/user'
    ]),
    (0, _extractidsmiddleware.Acl)('baseUserMetaUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.ProjectUserReqType === "undefined" ? Object : _nocodbsdk.ProjectUserReqType
    ]),
    _ts_metadata("design:returntype", Promise)
], BaseUsersController.prototype, "baseUserMetaUpdate", null);
BaseUsersController = _ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _baseusersservice.BaseUsersService === "undefined" ? Object : _baseusersservice.BaseUsersService
    ])
], BaseUsersController);
